import * as React from "react";
import Table from "@components/discountCodePolicy/Table";
import {Button, Card} from "antd";
import SearchComponent from "@components/discountCodePolicy/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import api from "@api/discount-code-policy";
import withPaginationComponent from "@hocs/withPaginationComponent";
import __i18n from "../../intl/__i18n";
import {DiscountCodePolicy} from "../../models/discountCodePolicy";



interface PropsFromHoc {
  data          :DiscountCodePolicy[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}


type AllProps = PropsFromHoc ;

const ListPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  
  const deleteItem = (item: DiscountCodePolicy): any => {
    const {onDeleteItem} = props;
    api.delete({
        params: {id: item.id}
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/discount-code-policies/create`}>
          <Button type={"primary"}>
            {__i18n("Create New Discount Policy")}
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        <Card className={`page-table-header`} bordered={false}>
          <SearchComponent search={search}/>
        </Card>
        
        <Table
          data={data}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteItem}
          loading={!isFetched}
        />
      </div>
    </div>
  );
};


export default whitListData(
  withPaginationComponent(ListPage),
  {
    fetchRequest: api.getList,
    paginationOnScroll: false
  }
);
